import { render, staticRenderFns } from "./spaceData.vue?vue&type=template&id=3756ce50&scoped=true&"
import script from "./spaceData.vue?vue&type=script&lang=js&"
export * from "./spaceData.vue?vue&type=script&lang=js&"
import style0 from "./spaceData.vue?vue&type=style&index=0&id=3756ce50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756ce50",
  null
  
)

export default component.exports